import React, { FC, useEffect, useState } from "react";
import { Modal } from "@shared/components/Modal";
import { ButtonPrimary, ButtonSecondary } from "@shared/components";
import { useDebounce } from "@shared/hooks";
import { useDispatch, useSelector } from "react-redux";
import { assignedToLead, checkIfPropertyCouldBeAssignedToLead } from "@containers/Properties/store/actions";
import { getPropertiesCheckForAssignState } from "@containers/Properties/store/selectors";
import * as sharedActions from "@shared/store/actions";
import "./index.scss";
import { showNotification } from "@shared/store/actions";

interface ModalAssignLeadToPropertyProps {
  onClose: () => void;
  data?: {
    leadId: number;
  };
}

export const ModalAssignLeadToProperty: FC<ModalAssignLeadToPropertyProps> = ({ onClose, data }) => {
  const dispatch = useDispatch();

  const [value, setValue] = useState<number>();
  const debounceValue = useDebounce<number>(value || 0, 500);

  const propertiesCheckForAssignState = useSelector(getPropertiesCheckForAssignState());

  const assign = () =>
    dispatch(
      assignedToLead.request({
        propertyId: +debounceValue,
        leadId: data?.leadId || 0,
        callback: () => {
          dispatch(sharedActions.hideModal());

          dispatch(
            showNotification({
              message: "Property successfully assigned.",
              appearance: "success",
            }),
          );
        },
      }),
    );

  useEffect(() => {
    if (!debounceValue) return;

    dispatch(checkIfPropertyCouldBeAssignedToLead.request(+debounceValue));
  }, [dispatch, debounceValue]);

  return (
    <div
      className={`modal-assign-lead-to-property ${
        debounceValue && propertiesCheckForAssignState.error ? "error" : "false"
      }`}
    >
      <Modal.Section>
        <Modal.Title>Property ID</Modal.Title>
        <Modal.Content>
          <input
            type="number"
            placeholder="Enter Property ID"
            onKeyDown={(e) => [".", "+", "-"].includes(e.key) && e.preventDefault()}
            onChange={(e) => setValue(+e.target.value)}
            value={value || ""}
          />{" "}
          {!!debounceValue && propertiesCheckForAssignState.error && (
            <div className="error-message">{propertiesCheckForAssignState.message}</div>
          )}
          {!!debounceValue && propertiesCheckForAssignState.property && (
            <div className="property">
              <b>
                {[
                  propertiesCheckForAssignState.property.mailing_address_zip,
                  propertiesCheckForAssignState.property.property_address,
                  propertiesCheckForAssignState.property.property_city,
                  propertiesCheckForAssignState.property.property_state,
                ]
                  .filter((i) => i)
                  .join(", ")}
              </b>
              {propertiesCheckForAssignState.property.county} ({propertiesCheckForAssignState.property.property_state})
            </div>
          )}
        </Modal.Content>
        <Modal.Actions>
          <ButtonSecondary onClick={onClose}>Cancel</ButtonSecondary>
          <ButtonPrimary
            type="submit"
            onClick={assign}
            disabled={!debounceValue || propertiesCheckForAssignState.error}
          >
            Save
          </ButtonPrimary>
        </Modal.Actions>
      </Modal.Section>
    </div>
  );
};
